import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Medicine: React.FC<SvgProps> = (props) => {
  return (
    <Icon height={24} width={24} viewBox="0 0 24 24" {...props}>
      <path
        d="M15.293 3.75C18.4448 3.75016 20.9999 6.3052 21 9.45703C21 10.908 20.4574 12.2345 19.5654 13.2412L19.5586 13.249L19.3418 13.4795L12 20.8213L6.96973 15.791L8.03027 14.7305L12 18.7002L18.2646 12.4355L18.4502 12.2383C19.1042 11.4964 19.5 10.5236 19.5 9.45703C19.4999 7.13363 17.6164 5.25016 15.293 5.25C14.2226 5.25 13.2468 5.64852 12.5039 6.30664L12.4082 6.3916L12.0244 6.77539L12 6.75391L11.9756 6.77539L11.5918 6.3916L11.4961 6.30664C10.7532 5.64851 9.77738 5.25 8.70703 5.25C6.38361 5.25013 4.50013 7.13361 4.5 9.45703C4.5 10.5312 4.89501 11.5129 5.55078 12.2529L4.42773 13.2471C3.5334 12.2376 3 10.9042 3 9.45703C3.00013 6.30518 5.55518 3.75013 8.70703 3.75C9.90282 3.75 11.0144 4.11818 11.9316 4.74707L12 4.67871L12.0684 4.74707C12.9856 4.11817 14.0972 3.75 15.293 3.75ZM12.75 12.4395L14.6895 10.5H17.25V12H15.3105L12.75 14.5605L9.75 11.5605L5.56055 15.75H3V14.25H4.93945L9.75 9.43945L12.75 12.4395Z"
        fill="currentColor"
      />
    </Icon>
  )
}
